/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ProductionPlanReportQuantityPage = lazyLoad(
  () => import('./index'),
  module => module.ProductionPlanReportQuantityPage
);
